import { Check, Crown } from "lucide-react";
import { useI18n } from "../i18n";
import { usePlans } from "../lib/plans";
import { fmtETB } from "../lib/api";

export const PACKAGE_FEATURES = {
  silver: ["pk_f_dashboard", "pk_f_id", "pk_f_support"],
  gold: ["pk_f_dashboard", "pk_f_id", "pk_f_support", "pk_f_priority"],
  gold_plus: ["pk_f_dashboard", "pk_f_id", "pk_f_support", "pk_f_priority", "pk_f_premium"],
};
const TIER_COLOR = { silver: "#B8C0CC", gold: "var(--gold)", gold_plus: "#E9C46A" };

export const PackageCards = ({ selected, onSelect, testPrefix = "package" }) => {
  const { t } = useI18n();
  const { activePlans, planName } = usePlans();
  return (
    <div>
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {activePlans.map((plan, i) => {
        const p = plan.key;
        const active = selected === p;
        const featured = plan.recommended;
        const features = plan.features?.some((x) => x.trim()) ? plan.features.filter((x) => x.trim()) : (PACKAGE_FEATURES[p] || []).map((k) => t(k));
        return (
          <div key={p} className={`lux-card relative flex flex-col p-7 fade-up transition-transform duration-300 hover:-translate-y-1 ${featured ? "md:-translate-y-3" : ""}`}
            style={{ animationDelay: `${i * 120}ms`, borderColor: active || featured ? "var(--gold)" : undefined }} data-testid={`${testPrefix}-card-${p}`}>
            {featured && <span className="absolute -top-3 left-7 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-widest" style={{ background: "var(--gold)", color: "#0A0D14" }}>{t("pk_recommended")}</span>}
            <div className="flex items-center gap-3">
              <Crown className="h-5 w-5" style={{ color: TIER_COLOR[p] || "var(--gold)" }} />
              <h3 className="font-serif text-2xl font-semibold" data-testid={`${testPrefix}-name-${p}`}>{planName(p)}</h3>
            </div>
            <p className="mt-6 text-xs uppercase tracking-widest text-muted-foreground">{t("pk_fee")}</p>
            <p className="mt-1 font-serif text-5xl font-semibold" data-testid={`${testPrefix}-fee-${p}`}>
              {fmtETB(plan.fee)} <span className="font-sans text-base font-medium text-muted-foreground">ETB</span>
            </p>
            <p className="mt-5 text-xs uppercase tracking-widest text-muted-foreground">{t("pk_reward")}</p>
            <p className="mt-1 font-serif text-3xl font-semibold gold-text" data-testid={`${testPrefix}-reward-${p}`}>
              {fmtETB(plan.reward)} <span className="font-sans text-sm font-medium text-muted-foreground">ETB</span>
            </p>
            <ul className="mt-6 flex-1 space-y-3 text-sm">
              {features.map((f, j) => (
                <li key={j} className="flex items-start gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0" style={{ color: "var(--gold)" }} />{f}</li>
              ))}
            </ul>
            {onSelect && (
              <button type="button" onClick={() => onSelect(p)} className={`mt-8 ${active ? "btn-gold" : "btn-ghost-gold"}`} data-testid={`${testPrefix}-select-${p}`}>
                {active ? t("pk_selected") : t("pk_choose")}
              </button>
            )}
          </div>
        );
      })}
    </div>
    </div>
  );
};
